import { Button, Grid, Input, NumberFormatter, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconSearch } from "@tabler/icons-react";
import { CellDoubleClickedEvent } from "ag-grid-community";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import { cobalt_blue } from "../../../../const/variables";

interface AccountantAccount {
  id: number;
  accountantAccount: string;
  accountantAccountName: string;
  accountLevel: number;
  createBy?: string | null;
  createDate?: Date | null;
  lastUpdateDate?: Date | null;
  lastUpdateBy?: string | null;
}

const DebtCodeForFees = ({
  handleChooseCodeForFees,
  navigate,
  isChooseTaiKhoan,
  openFormCustomer,
  disible,
  children,
  RowIndex,
  type,
}: {
  handleChooseCodeForFees: Function;
  navigate?: any;
  isChooseTaiKhoan: boolean;
  openFormCustomer?: any;
  disible?: boolean;
  children?: boolean;
  RowIndex?: number;
  paramDetailsEditThu?: CellDoubleClickedEvent<any>;
  paramDetailsEditDonHang?: CellDoubleClickedEvent<any>;
  type?: string;
}) => {
  const [data, setData] = useState<AccountantAccount[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [search, setSearch] = useState({
    keySearch: "",
    Phone: "",
    TaxCode: "",
    Code: "",
  });
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 25,
  });
  const headerRef = React.useRef<HTMLDivElement>(null);

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const columns = React.useMemo<MRT_ColumnDef<AccountantAccount>[]>(
    () =>
      [
        {
          accessorKey: "STT",
          header: "STT",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
          Cell: ({ row }) => <Text size="12.5px">{row.index + 1}</Text>,
          size: 50,
        },
        {
          accessorKey: "accountantAccount",
          header: "Mã tài khoản",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
          size: 150,
        },
        {
          accessorKey: "accountantAccountName",
          header: "Tên tài khoản",
          size: 300,
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
        },
        {
          accessorKey: "accountLevel",
          header: "Cấp độ tài khoản",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
        },
        {
          accessorKey: "createDate",
          header: "Ngày tạo",
          Cell: ({ renderedCellValue }: any) => (
            <Text fw={600}>
              <NumberFormatter
                thousandSeparator={","}
                value={renderedCellValue}
              ></NumberFormatter>
            </Text>
          ),
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
        },
        {
          accessorKey: "lastUpdateDate",
          header: "Ngày cập nhật lần cuối",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
        },
      ] as MRT_ColumnDef<(typeof data)[0]>[],
    []
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }

    if (type === "CH") {
      url += `&ThanEqualLevel=${3}`;
    }

    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmAccount/get-list${url}`
      );
      if (response && response.success) {
        let result = response?.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response?.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    //   getRowId: (row) => row?.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "62.5vh", minHeight: "300px" },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    onPaginationChange: (e) => {
      setPagination(e);
    },
    manualPagination: true,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        handleChooseCodeForFees(
          row.original,
          isChooseTaiKhoan,
          openFormCustomer,
          children,
          RowIndex
        );
        modals.closeAll();
      },
      sx: {
        cursor: "pointer",
      },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
          border: "1px solid #dee2e6",
          padding: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid style={{ width: "100%" }}>
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Nhập từ khóa tìm kiếm"
              type="text"
              leftSection={
                <IconSearch size={"20"} color={cobalt_blue.base}></IconSearch>
              }
              onChange={(e) => {
                handleChangeSearchValue(e.target.value ?? "", "keySearch");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default DebtCodeForFees;
